
import { Component, Vue } from 'vue-property-decorator'
import {getSyDictDataInfo} from "@/api/commonConfig";
@Component({
  name: 'DistributionWayPickerDialog'
})
export default class DistributionWayPickerDialog extends Vue {
  showDialog = false
  // 默认选中项的索引
  defaultIndex = 0
  columns = []

    created() {
      this.getDistributionWayList()
    }

    // 获取配送方式数据字典
    getDistributionWayList() {
        getSyDictDataInfo({dictTypeId: 'distributionWay'}).then((res) => {
            this.columns = res.data || []
        })
    }

    /**
     *
     * @param id 配送方式id
     */
  show (id) {
    this.defaultIndex = this.columns.findIndex(item => Number(item.dataId) === Number(id))
    this.showDialog = true
  }

  onCancel () {
    this.showDialog = false
  }

  onConfirm (obj) {
    this.$emit('getDistributionWay', obj)
    this.showDialog = false
  }
}
